module.exports = __webpack_public_path__ + "static/scale-model-of-florida-historic-capitol-museum-in-tallahassee-florida-5190aa34ccd2296de1c7f6695dc1fd76.png";